import styled from 'styled-components';
import { Form } from 'formik';
import breakpoint from 'Styles/breakpoints';
import { fontTitle, fontBody } from 'Styles/fonts';
import { white } from 'Styles/colors';
import { Error } from '../FormInput/FormInput.styled';
import TextInputOriginal from '../TextInput/TextInput';
import Button from '../Button/Button';

export const FormText = styled.div`
  ${fontTitle(24)};
  color: ${white};
  min-height: 36px;
  padding-bottom: 16px;
  margin: 0;

  ${breakpoint('medium')} {
    height: auto;
  }
`;

export const TextInput = styled(TextInputOriginal)`
  ${breakpoint('large')} {
    width: 272px;
  }
`;

export const EmailWrapper = styled.div`
  width: 100%;

  ${breakpoint('large')} {
    display: block;
    height: 73px;
    padding-top: 0;
  }
`;

export const EmailForm = styled(Form)`
  justify-content: center;

  ${Error} {
    color: ${white};
  }

  ${breakpoint('large')} {
    padding: 0 7.5px 0 7.5px;
    display: flex;
  }
`;

export const EmailButton = styled(Button)`
  ${fontTitle(16)};
  text-transform: none;
  width: 100%;
  margin-top: 8px;

  ${breakpoint('large')} {
    height: 44px;
    width: 103px;
    margin-left: 8px;
    margin-top: 0;
    padding: 0;
  }
`;

export const Disclaimer = styled.p`
  ${fontBody(12)};
  color: ${white};
  margin: 0 auto 16px auto;
  max-width: 383px;

  a {
    color: ${white};
  }

  ${breakpoint('large', { type: 'down' })} {
    margin-top: 12px;
  }
`;
